import { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/hooks/useStores';
import { lazyRoute } from '@/routing/lazyRoute';

const DecisionAnswerToast = lazyRoute(
  () => import('./DecisionAnswerToast'),
  (module) => module.DecisionAnswerToast,
);

/**
 * Where `DecisionAnswerToast` mounts (`Layout.tsx`), loaded only once an answer has raised a toast,
 * so the launch entry carries the store and none of the `decisions` words the toast says.
 */
export const DecisionAnswerToastSlot = observer(function DecisionAnswerToastSlot() {
  const { decisionAnswerToastStore } = useStores();
  if (!decisionAnswerToastStore.toast) return null;
  return (
    <Suspense fallback={null}>
      <DecisionAnswerToast />
    </Suspense>
  );
});
